import inView from 'in-view'

const load = () => {

  document.querySelectorAll('.js_animation.js_animation__fix').forEach((element, idx) => {
    element.classList.add('inview-tag-' + idx)
    inView('.inview-tag-' + idx).once('enter', function (elem) {
      elem.classList.add('js_animation__fired')
    })
  })

  inView('.js_animation:not(.js_animation__fix):not(.js_animation__fired)')
    .on('enter', function (elem) {
      elem.classList.add('js_animation__fired')
    })

  inView('.js_animation:not(.js_animation__fix)')
    .on('exit', function (elem) {
      elem.classList.remove('js_animation__fired')
    })

  inView('.js_animation:not(.js_animation__fix):not(.js_animation__fired)').check()

}
export default load